import Controller from "@ember/controller";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class IpsOverviewController extends Controller {
  @service http;

  get project() {
    return this.model.project;
  }

  loadIpCosts = task(async () => {
    return this.http.request({ url: `${ENV.apiBaseUri}/ip/estimatedcost?projectkey=${this.project.id}` });
  });
}
